module.exports = __webpack_public_path__ + "static/media/politikat.df8f4974.jpg";